import axios from 'axios'
import { attachAuthInterceptors } from '@/platform/http/authBridge'
import { platformEnv } from '@/platform/config/env'
import { createHttpClient } from '@/platform/http/client'

const client = createHttpClient(platformEnv.ecomApiUrl)

const directClient = axios.create({ baseURL: platformEnv.ecomApiUrl, timeout: 20_000 })
attachAuthInterceptors(directClient)

export interface PublishStatusResponse {
  version: number
  deployed_at?: string
  deployed_by?: string
  meta?: {
    taxonomy_count: number
    term_count: number
    product_count: number
    variant_count: number
  }
}

export const catalogSnapshotApi = {
  getSnapshot: async (): Promise<any> => {
    const res = await directClient.get('/v1/admin/catalogs/snapshot')
    if (res.data && typeof res.data === 'object' && 'data' in res.data && 'success' in res.data) {
      return res.data.data
    }
    return res.data
  },

  publish: async (): Promise<{ success: boolean; version: number; meta: any }> => {
    const res = await client.request<{ success: boolean; version: number; meta: any }>({
      url: '/v1/admin/catalogs/publish',
      method: 'POST',
    })
    return res.data
  },

  getPublishStatus: async (): Promise<PublishStatusResponse> => {
    const res = await client.request<PublishStatusResponse>({
      url: '/v1/admin/catalogs/publish/status',
      method: 'GET',
    })
    return res.data
  },
}
